/** Matches backend `CandidateSortOrder` enum (EnumMember string values). */
export const CandidateSortOrder = Object.freeze({
  NameAsc: 'nameAsc',
  NameDesc: 'nameDesc',
  LastBookingDateAsc: 'lastBookingDateAsc',
  LastBookingDateDesc: 'lastBookingDateDesc',
  NoOfBookingsAsc: 'noOfBookingsAsc',
  NoOfBookingsDesc: 'noOfBookingsDesc',
})

export default CandidateSortOrder
